import React, { useEffect, useState } from 'react';
// import * as XLSX from 'xlsx'; // ไม่ได้ใช้แล้ว - ถอด package xlsx ออกจาก package.json แล้ว (2026-09-18) ใช้ xlsx-js-style แทน
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { ConvertDate } from '../../Function/ConvertDate';

function ExcelExportComponent(props) {
  const { dataInput = [], equipmentName } = props
  const [optionData, setOptionData] = useState(null);

  useEffect(() => {
    let option = []
    if (dataInput?.length > 0) {
      dataInput.map((i, idx) => (
        option.push({
          ลำดับ: idx + 1,
          เลขครุภัณฑ์: i.item_format,
          ชื่อครุภัณฑ์: i.detail,
          ประเภทครุภัณฑ์: i.type_name,
          วันและเวลาที่ยืม: ConvertDate(i.date_borrow).toOnlyDateTHYear(),
          วันและเวลาที่คืน: ConvertDate(i.date_return).toOnlyDateTHYear(),
          เพื่อใช้งาน: i.remark_borrow,
          สถานะ: i.status === 1 ? "จ่าย" : i.status === 0 ? "จอง" : i.status === 2 && "คืน",
          ผู้ยืม: i.users_name_borrow,
          ผู้คืน: i.users_name_returner,
          ผู้ให้ยืม: i.user_name_allot,
          ผู้รับคืน: i.user_name_repatriate
        })
      ))
      setOptionData(option)
    }
  }, [dataInput, equipmentName])

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(optionData);
    worksheet['!cols'] = [
      { wpx: 50 },   // ลำดับ (ความกว้าง 50 พิกเซล)
      { wpx: 150 },  // เลขครุภัณฑ์ (ความกว้าง 150 พิกเซล)
      { wpx: 250 },  // ชื่อครุภัณฑ์ (ความกว้าง 250 พิกเซล)
      { wpx: 200 },  // ประเภทครุภัณฑ์ (ความกว้าง 200 พิกเซล)
      { wpx: 150 },  // วันและเวลาที่ยืม (ความกว้าง 150 พิกเซล)
      { wpx: 150 },  // วันและเวลาที่คืน (ความกว้าง 150 พิกเซล)
      { wpx: 200 },  // เพื่อใช้งาน (ความกว้าง 200 พิกเซล)
      { wpx: 100 },  // สถานะ (ความกว้าง 100 พิกเซล)
      { wpx: 150 },  // ผู้ยืม (ความกว้าง 150 พิกเซล)
      { wpx: 150 },  // ผู้คืน (ความกว้าง 150 พิกเซล)
      { wpx: 150 },  // ผู้ให้ยืม (ความกว้าง 150 พิกเซล)
      { wpx: 150 },  // ผู้รับคืน (ความกว้าง 150 พิกเซล)
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(blob, "รายงานการยืมอุปกรณ์ใช้ภายนอกสำนักงาน.xlsx");
  };

  return (<a className="btn btn-success" onClick={exportToExcel}><i className="fa-solid fa-file-excel"></i></a>);
}

export default ExcelExportComponent;